<template lang="pug">
v-app
  home-app-bar(@clicked="menuClick" :cmsOn="$_sms_isAvailable")
  v-main.home-bg
    v-fade-transition(mode="out-in")
      router-view
  home-try(v-if="$_meeting_isAvailable && $route.name!='Box'" alias="home") 
  home-app-footer(@clicked="menuClick" :cmsOn="$_sms_isAvailable")

  login(v-model="dialogLogin")
  oneLogin(v-model="dialogOneLogin")

  app-dialog(v-model="dialogErrorLogout" header="Ошибка при авторизации") 
    app-card-title {{ textErrorLogout }} 

  registation(v-model="newCourt")

</template>

<style module lang="scss">
$ee: #000000;
</style>

<script>
import login from '@/pages/access/Login'
import oneLogin from '@/pages/access/OneLogin'
import registation from '@/pages/access/Registation'
import { $_user_utils } from '@/common/UserUtils'
import Meeting from '@/common/Meeting'
import homeAppBar from './AppBar'
import homeTry from './Try'
import homeAppFooter from './AppFooter'
import { courtService } from '@/_services'

import { mapGetters } from 'vuex'

var getParams = function (url) {
  var parser = document.createElement('a')
  parser.href = url
  
	var query = parser.search.substring(1)
  var vars = query.split('&')
  
  var params = {}
  if (vars.length == 0) return params
  
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=')
		params[pair[0]] = decodeURIComponent(pair[1])
	}
	return params
}

export default {
  mixins: [$_user_utils, Meeting],
  components: {
    login,
    oneLogin,
    registation,
    homeAppBar, 
    homeTry, 
    homeAppFooter 
  },
  created() {
    courtService.setCourtAlias()

    if(this.$_sms_isAvailable)
      this.$store.dispatch('page/INIT')

    if (localStorage.getItem("error")) {
      this.textErrorLogout = localStorage.getItem("error")
      this.dialogErrorLogout = true
      localStorage.removeItem('error')
    }
    if (localStorage.getItem("access_token")) {
      this.$user_utils_goToStartPage()
    }

  },


  mounted() {
    this.checkCourt()
    document.title = "Универсальная платформа для судов и участников судопроизводства";
  },

  computed: {
    ...mapGetters('page', ['nav','isNavLoaded']),

    $_sms_isAvailable () {
      return window.settings.cms && window.settings.cms.available==true
    }
  },

  methods: {
    menuClick(str){
      switch (str) {
        case "cab": {
          this.showLoginDialog()
          break
        }
        case "esia": {
          this.goToGosuslugi()
          break
        }
        case "isadv": {
          this.goToISAdv()
          break
        }
        case "pin": {
          this.showOneLoginDialog()
          break
        }
        case "search": {
          this.showLoginDialog()
          break
        }
        default: console.log(str)
      }
    },

    showLoginDialog() {
      this.dialogLogin = true
    },

    showOneLoginDialog() {
      this.dialogOneLogin = true
    },
    
    goToGosuslugi () {
      let { back } = getParams(window.location.href)
      location.href = this.$_meeting_makeEsiaUrlWithRoom(back) 
    },

    goToISAdv () {
      let { back } = getParams(window.location.href)
      location.href = this.$_meeting_makeEsiaUrlWithRoom(back) 
    },



    checkCourt () {
      courtService.getCourt().then(data => {
        if (data.length == 0) this.newCourt = true
      })
    }, 

  },

  data () {
    return {
      dialogLogin: false,
      dialogOneLogin: false,
      newCourt: false,
      dialogErrorLogout: false,
      textErrorLogout: '',
      pages: null
    }
  }
}
</script>

<style lang="sass" scoped>
  .home-bg
    background: #0E9DBC url(/bg.png) top right no-repeat
</style>
